document.addEventListener('DOMContentLoaded', function () {
    const body = document.querySelector('body');
    const header = document.querySelector('.wcl-header');
    if (!header) return;

    const menu = header.querySelector('.menu');
    if (!menu) return;

    const menuBody = menu.querySelector('.menu__body');
    if (!menuBody) return;

    const menuIcon = header.querySelector('.menu-icon');
    if (!menuIcon) return;

    function closeAllSubmenus(except = null) {
        const openSubmenus = document.querySelectorAll('.menu-item-has-children.open');
        if (openSubmenus.length > 0) {
            openSubmenus.forEach(item => {
                if (item !== except) {
                    item.classList.remove('open');
                }
            });
        }
    }

    function closeMenu() {
        menuIcon.classList.remove('is-open');
        menu.classList.remove('is-open');
        body.classList.remove('lock');
        closeAllSubmenus();
    }

    menuIcon.addEventListener('click', function () {
        this.classList.toggle('is-open');
        menu.classList.toggle('is-open');
        body.classList.toggle('lock');

        if (!this.classList.contains('is-open')) {
            closeAllSubmenus();
        }
    });

    const menuItems = menuBody.querySelectorAll('.menu-item:not(.menu-item-has-children) a');
    if (menuItems.length > 0) {
        menuItems.forEach(item => {
            item.addEventListener('click', closeMenu);
        });
    }

    const submenuLinks = document.querySelectorAll('.menu-item-has-children > a');
    if (submenuLinks.length > 0) {
        submenuLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const parent = this.parentElement;

                closeAllSubmenus(parent);

                parent.classList.toggle('open');
            });
        });
    }
});
